import { zIndices } from '../../tokens/zIndices';
import { SharedPanelProps } from '../../types/SharedPanelProps';
import { RIGHT_SPACE } from '../PageSidebar/constants';

export const getPanelPosition = ({
  mode,
  offsetTop,
  position,
  hideRailGutter = false,
}: {
  mode: SharedPanelProps['mode'];
  offsetTop: SharedPanelProps['offsetTop'];
  position: SharedPanelProps['position'];
  hideRailGutter?: SharedPanelProps['hideRailGutter'];
}) => {
  let positionStyle = {};
  if (mode === 'floating') {
    positionStyle = {
      bottom: 4,
      right: 4,
      top: '80px',
    };
  } else if (mode === 'floating-full-width') {
    positionStyle = {
      bottom: 3,
      left: 3,
      right: 3,
      top: '76px',
    };
  } else if (position === 'right') {
    positionStyle = {
      bottom: mode === 'inline' ? '64px' : 0,
      right: 0,
      top: offsetTop ? `calc(64px + ${offsetTop}px)` : '64px',
    };
  } else if (position === 'left') {
    positionStyle = {
      bottom: mode === 'inline' ? '64px' : 0,
      left: 0,
      top: offsetTop ? `calc(64px + ${offsetTop}px)` : '64px',
    };
  } else if (mode === 'fullscreen') {
    positionStyle = {
      top: 0,
      right: 0,
    };
  } else if (mode === 'floating-sidepanel') {
    positionStyle = {
      bottom: 3,
      // Without the rail gutter, fall back to the same right padding the
      // `floating` panel uses so the two read consistently.
      right: hideRailGutter ? 4 : `calc(12px + ${RIGHT_SPACE})`,
      top: '76px',
    };
  }

  return {
    position: 'fixed',
    ...positionStyle,
  };
};

export const basePanelWrapperStyle = ({
  mode,
  zIndex = zIndices.panel,
  expandWidth,
}: {
  mode: SharedPanelProps['mode'];
  zIndex?: string;
  expandWidth?: number | string;
}) => ({
  boxShadow: mode === 'inline' ? 'none' : 'raised',
  zIndex,
  borderRadius: 'ml',
  ...(expandWidth !== undefined && {
    width: expandWidth,
  }),
});
